import * as bootstrap from 'bootstrap';

// PrismJS und Theme importieren
import Prism from 'prismjs';
import 'prismjs/themes/prism-okaidia.css'; 

// Kopier-Funktion für alle Snippets initialisieren
document.addEventListener('DOMContentLoaded', () => {
    Prism.highlightAll();

    // Event-Listener für Kopieren-Buttons
    document.querySelectorAll('.btn-copy').forEach(button => {
        button.addEventListener('click', () => {
            const codeBlock = button.closest('.code-snippet-wrapper').querySelector('code');
            const codeText = codeBlock.innerText;

            navigator.clipboard.writeText(codeText).then(() => {
                const originalText = button.innerHTML;
                button.innerHTML = 'Gekopiert!';
                button.classList.replace('btn-outline-light', 'btn-success');

                setTimeout(() => {
                    button.innerHTML = originalText;
                    button.classList.replace('btn-success', 'btn-outline-light');
                }, 2000);
            });
        });
    });
});